// extracted by mini-css-extract-plugin
module.exports = {"lia-user-system-text":"MessageModerator_lia-user-system-text__wwh_v"};